import React from 'react';
import {ROUTES} from "../utils/constants";
import HeaderContainer from "../containers/HeaderContainer"
import {Link} from "react-router-dom";

const Error404 = (props) => {
  return (
    <div>
      <HeaderContainer/>
      <div className="page-container">
        <div className="not-found">
          <div className="error-code">404</div>
          <div className="error-msg">We can't seem to find your page.</div>
          <div className="not-found__home-link"><Link to={ROUTES.PROJECTS}>Return Home</Link></div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
